const styles = theme => ({
  icon: {
    marginRight: theme.spacing(1)
  }
})

export default styles
